export enum Language {
    EN = 'en',
    JA = 'ja',
}

export const language = [
    { value: Language.EN, label: 'English' },
    { value: Language.JA, label: '日本語' },
];
